import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=4088148c"
import script from "./Relatorio.vue?vue&type=script&lang=js"
export * from "./Relatorio.vue?vue&type=script&lang=js"
import style0 from "./Relatorio.vue?vue&type=style&index=0&id=4088148c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports